"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cell = void 0;

/**
 * @fileOverview Cross
 */
var Cell = function Cell(_props) {
  return null;
};

exports.Cell = Cell;
Cell.displayName = 'Cell';